import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=094197b1&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=094197b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094197b1",
  null
  
)

export default component.exports